import { Button, Form, Input, Modal, message } from "antd";
import { IVideo } from "../../interfaces";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useState } from "react";
import  { recordApi } from "../../api";

interface IProps {
  video: IVideo;
  onDone: (video: IVideo) => void;
}

export default function ActionButton({ video, onDone }: IProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [form] = Form.useForm();

  const handleUpdate = async () => {
    setIsLoading(true);
    let url = "";
    if (video.status === "schedule") {
      url = "go-live";
    }
    if (["ended", "live"].includes(video.status)) {
      url = `end-live`;
      setCount(count + 1);
    }

    if (video.videoType === "ytst") {
      url = "end-youtube";
    }

    try {
      const { data } = await recordApi.get<IVideo>(url, {
        params: {
          videoId: video._id,
          stream_key: video.stream_key,
          ...(form.getFieldValue("hd_url") !== undefined && {
            hd_video_url: form.getFieldValue("hd_url"),
          }),
          ...(count >= 2 && { force: 1 }),
        },
      });
      onDone(data);
      setIsLoading(false);
      return;
    } catch (error: any) {
      console.log({ error }, "call");
      message.error(
        error?.response?.data?.error ||
          error?.message ||
          "Server Error",
      );
      setIsLoading(false);
    }
  };

  const showConfirmation = () => {
    Modal.confirm({
      title: "Are you sure you want to do this?",
      icon: <ExclamationCircleFilled />,
      content: video.status === "schedule" && (
        <>
          <Form
            name="basic"
            initialValues={{ remember: true }}
            layout="vertical"
            // onFinish={onFinish}s
            form={form}
          >
            <Form.Item
              label="Enter HD URL"
              name="hd_url"
              rules={[
                {
                  required: false,
                  validator: (_, value) => {
                    if (value.startsWith("https://")) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "URL must start with https://example.m3u8 or https://youtube.com/embed/xysdfsa",
                      ),
                    );
                  },
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Form>
        </>
      ),
      onOk() {
        handleUpdate();
      },
      onCancel() {
        form.resetFields();
      },
    });
  };


  if (video.status === "schedule")
    return (
      <Button
      onClick={showConfirmation}
        type="primary"
        loading={isLoading}
      >
        Go Live
      </Button>
    );

  if (["live", "ended"].includes(video.status) && video.videoType !== "yt") {
    return (
      <Button
      onClick={showConfirmation}
      type="primary"
      loading={isLoading}
    >
      End Live
    </Button>
    );
  }
  return <div />;
}
